// extracted by mini-css-extract-plugin
module.exports = {"buttonsInRow":"CV-xR_","button":"naQL7L","buttons":"zlg8sO","footer":"BmALA-","textCancel":"_2BuqAf","shine-lines":"_3a54LA"};